@if (gridOptions) {
  <dv-grid [actions]="actions">
    <ag-grid-angular
      vtGridRowEditing
      dvGridInSidesheet
      class="ag-theme-devinco"
      [gridOptions]="gridOptions">
    </ag-grid-angular>
  </dv-grid>
}
